$(function () {
    $('.see-in-store-modal__wrapper').kendoWindow({
        size: 'auto',
        title: 'On Display At:',
        modal: {
            preventScroll: true
        },
        position: {
            top: '50%',
            left: '50%'
        },
        maxHeight: 400,
        draggable: false,
        resizable: false,
        scrollable: true,
    })

    var modal = $('.see-in-store-modal__wrapper').data('kendoWindow')

    modal.wrapper.addClass('see-in-store-modal')

    $('.see-in-store__toggle').on('click touch', function (event) {
        event.preventDefault()
        modal.open()
    })
})